import React, { useEffect, useState } from "react";
import { api } from "@/lib/auth";
import { PageHeader } from "@/pages/Classes";

export default function Team() {
  const [members, setMembers] = useState([]);
  useEffect(() => { api.get("/team").then(r => setMembers(r.data || [])); }, []);
  const groups = {
    management: members.filter(m => m.category === "management"),
    instructor: members.filter(m => m.category === "instructor"),
    competition: members.filter(m => m.category === "competition"),
  };

  return (
    <>
      <PageHeader eyebrow="The people" title="Meet the team" sub="Founders, instructors and our competition crew." />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-12" data-testid="team-page">
        {[["management","Management"],["instructor","Instructors"],["competition","Competition Team"]].map(([k,label]) => (
          groups[k].length > 0 && (
            <section key={k} className="mb-16">
              <div className="eyebrow mb-6">{label}</div>
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                {groups[k].map(m => (
                  <div key={m.id} className="card-surface overflow-hidden card-hover" data-testid={`team-member-${m.id}`}>
                    {m.photo && <img src={m.photo} alt={m.name} className="w-full aspect-[3/4] object-cover" />}
                    <div className="p-4">
                      <div className="font-display text-2xl uppercase leading-none">{m.name}</div>
                      {m.role && <div className="text-red-500 text-xs uppercase tracking-widest mt-2 font-bold">{m.role}</div>}
                      {m.bio && <p className="text-zinc-400 text-sm mt-3">{m.bio}</p>}
                      {m.styles && <div className="text-zinc-500 text-xs mt-3">Styles: {m.styles}</div>}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )
        ))}
        {members.length === 0 && (
          <div className="text-center py-24 text-zinc-500" data-testid="team-empty">
            No team members yet. Toggle "Show on team" from Admins & Team.
          </div>
        )}
      </div>
    </>
  );
}
